import { IonChip, IonIcon, IonLabel } from '@ionic/react';
import { animated, useSpring } from '@react-spring/web';
import { mailUnreadOutline } from 'ionicons/icons';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';

interface NewMessageChipProps {
  hidden: boolean;
  onClick: () => void;
}

const NewMessageChip = memo((props: NewMessageChipProps): ReactElement => {
  const { hidden, onClick } = props;
  const { i18n } = useTranslation();
  const springProps = useSpring({
    opacity: hidden ? 0 : 1,
    willChange: 'opacity',
  });

  return (
    <animated.div
      style={{
        ...springProps,
        visibility: springProps.opacity.to((o) =>
          o === 0 ? 'hidden' : 'visible'
        ),
      }}
    >
      <IonChip className="shadow chat-chip-new-message" onClick={onClick}>
        <IonIcon
          className="chat-chip-new-message-icon"
          icon={mailUnreadOutline}
        />
        <IonLabel>{i18n.t('common:chat_new_message')}</IonLabel>
      </IonChip>
    </animated.div>
  );
});

NewMessageChip.displayName = 'NewMessageChip';

export { NewMessageChip };
